module.exports = __webpack_public_path__ + "components/MapControl/svg/Synagoga zabytkowa.svg?fc2ca889";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Synagoga zabytkowa.svg
// module id = 2004
// module chunks = 0